import {Avatar, AvatarRootProps} from '@chakra-ui/react';

const SIZES = {'2xs': '1rem', xs: '1.5rem', sm: '2rem'} as const;

interface UserAvatarProps extends Omit<AvatarRootProps, 'size'> {
    name?: string;
    src?: string;
    size?: keyof typeof SIZES;
}

export function UserAvatar({name, src, size = 'sm', ...rootProps}: UserAvatarProps) {
    return <Avatar.Root boxSize={SIZES[size]} {...rootProps}>
        <Avatar.Fallback name={name}/>
        {src && <Avatar.Image src={src} alt={name} referrerPolicy="no-referrer"/>}
    </Avatar.Root>;
}